const init = () => {
  const div = document.createElement('div');
  div.style.overflow = 'scroll';
  div.style.visibility = 'hidden';
  document.body.appendChild(div);
  const scrollbarWidth = div.offsetWidth - div.clientWidth;
  document.body.removeChild(div);
  document.documentElement.style.setProperty('--scrollbar', `${scrollbarWidth}px`);
  // ヘッダー高さの監視
  const header = document.querySelector('#js-header');
  if (header) {
    const updateHeaderHeight = () => {
      document.body.style.setProperty('--h_height', `${header.offsetHeight}px`);
    };
    updateHeaderHeight();
    const resizeObserver = new ResizeObserver(updateHeaderHeight);
    resizeObserver.observe(header);
  }

}

const resize = () => {
}

const resizeW = () => {
  const div = document.createElement('div');
  div.style.overflow = 'scroll';
  div.style.visibility = 'hidden';
  document.body.appendChild(div);
  const scrollbarWidth = div.offsetWidth - div.clientWidth;
  document.body.removeChild(div);
  document.documentElement.style.setProperty('--scrollbar', `${scrollbarWidth}px`);
}

const scroll = () => {
}

export {
  init,
  resize,
  resizeW,
  scroll,
};